import Header from "@components/Header";
import { SupportedLanguage } from "@onetutor/shared/type";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import privacyPolicyDE from "./privacy.de.md?raw";
import privacyPolicyEN from "./privacy.en.md?raw";

function PrivacyPage() {
  const { i18n } = useTranslation();

  const privacyPolicy =
    i18n.language === SupportedLanguage.EN ? privacyPolicyEN : privacyPolicyDE;

  return (
    <Header>
      <div className="markdown prose mx-auto max-w-3xl">
        <ReactMarkdown>{privacyPolicy}</ReactMarkdown>
      </div>
    </Header>
  );
}

export default PrivacyPage;
